import React, {useState, useEffect} from 'react'

import SingleGame from './SingleGame'

function TeamSpecific({id}) {
  const [NHLGames, setNHLGames] = useState([])
  const [display, setDisplay] = useState(false) 
  useEffect(() => {
    setDisplay(false)
    GetNHLGames();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  const GetNHLGames = async () => {
    var dt = new Date();

    // Generate array of dates for the last 10 days (reduced from 20)
    const dates = [];
    for (let i = 0; i <= 10; i++) {
      const d = new Date(dt);
      d.setDate(dt.getDate() - i);
      dates.push(d.toJSON().slice(0, 10));
    }

    try {
      // Fetch all dates in parallel using new NHL API with CORS proxy
      const responses = await Promise.all(
        dates.map(date => fetch(`https://hehe.nhlrecap.com/?https://api-web.nhle.com/v1/score/${date}`, {
          headers: {
            'x-cors-api-key': 'temp_ec89abfc07d1cd3d760c3e4397975d32'
          }
        }))
      );
      const allGames = await Promise.all(responses.map(r => r.json()));

      // Transform and filter by team ID(s) - support multiple IDs
      const teamIds = id.toString().split(',').map(tid => parseInt(tid.trim()));
      const formattedData = allGames.map((data, idx) => ({
        date: dates[idx],
        games: (data.games || []).filter(g =>
          teamIds.includes(g.homeTeam.id) || teamIds.includes(g.awayTeam.id)
        )
      })).filter(day => day.games.length > 0);

      // Keep latest first, limit to 10 games
      setNHLGames(formattedData.slice(0, 10));
      setDisplay(true);
    } catch (error) {
      console.error('Error fetching team games:', error);
      setDisplay(true);
    }

  }


    const games = NHLGames.map(game => {
      let ts = new Date(game.date)
      return (
        <div className='singlegame-game' key={game.date} >
        <h2 style={{margin: "1em", textAlign: 'center'}}>{ts.toLocaleDateString()}</h2>
        <div className="singledategame">
        <SingleGame games={game.games} key={game.date} />
        </div>
        </div>
      )
    })


    return (
      <div 
      className="allgames-team-spesific">
     {display 
     ? games
     :    <div className="spinner-container">
     <div className="loading-spinner">
     </div>
   </div>}
   </div>
    )

}

export default TeamSpecific